import React, { useEffect } from 'react'
// import './Cart.css';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setHeaderColor, setloading } from '../../Redux/ActionCreater';
import CommonBanner from '../Common/CommonBanner';
import BottomInfo from '../Common/BottomInfo';
import banner from '../../Assets/images/success-banner.png'
export default function ThankyouPageEbooks() {
  let navigation = useNavigate();
  let dispatch = useDispatch()
  let token = localStorage.getItem("token");
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setHeaderColor("#facee1"));
    dispatch(setloading(false));
  }, [])
  return (

    <>
      <CommonBanner bannerImage={banner} />
      <section className="thtopcontainer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-9 col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
              <h2>Hallo meine Liebe,</h2>
              <p>vielen lieben Dank für deine Bestellung!<br/>
Wir freuen uns riesig, dich auf deiner Fitnessreise zu begleiten und wünschen dir ganz viel Freude mit deinem neuen E-Book.<br/>
Dein Download ist jetzt sofort verfügbar – schau einfach in dein Postfach (oder deinen Spam-Ordner, falls du nichts findest). Dort findest du den Link zu deinem E-Book und kannst direkt loslegen!<br/>
Wenn du in der Zwischenzeit Fragen hast oder Unterstützung brauchst, melde dich gerne jederzeit unter support@shapebysarah.com.<br/>
Ganz viel Spaß beim Lesen und Umsetzen! 💪
              </p>
        
              <div class="commentuser"><strong>- Deine Sarah</strong></div>
            </div>
          </div>
        </div>
      </section>
      {/* <div className='container'> */}
      {/* <div className="checkout-scard card border-0 rounded pb-5">
        <div className="card-body text-center">
          <p className="card-icon">
            <i><IoMdCheckmarkCircleOutline /></i>
          </p>
          <h4 className="card-title">Danke für Ihren Einkauf!</h4>
          <p className="card-text mb-1">
          {token?"Sie können alle Ihre Bestellungen auf der Seite „Bestellhistorie“ einsehen.":"Wir haben alle Bestelldetails an Ihre E-Mail gesendet."}
          </p>
          
         {token&& <Link to={"/dashboard?tab=order"}>
            <p className="card-text ordridbg my-3" onClick={() => { navigation("/dashboard?tab=order") }}>
              <b>Kaufhistorie</b>
            </p>
          </Link>}
        </div>
      </div> */}
      {/* </div> */}
      {/* <BottomInfo/> */}
    </>

  )
}
